import React, { useEffect, useRef, useState } from "react";
import { Button, Card, Modal, OverlayTrigger, Spinner, Tooltip } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { getTickets } from "../../../service/api/ticket/getTickets";
import ServiceRequestDetails from "../../serviceRequestDetails/serviceRequestDetails";
import {
    btnAcceptService,
    btnAcceptedByotherPro,
    btnConnect,
    btnJoinVideo,
    btnOpenJobs,
    btnRejectService,
    btnRejectedService,
    btnRejectedServiceMsg,
    btnResendLink,
} from "../../../dataBaseFile/alert";
import "../home.scss";
import { Form } from "react-bootstrap";
import acceptServiceImg from '../../../media/images/proDashboardAssets/acceptServiceImg.png'


import proIcon from "../../../media/images/pro-icon.png";
import updateAvailabilityApi from "../../../service/api/user/updateAvailability";
import {
    txtClosed,
    txtPauseJobs,
    txtReadyForJobs,
} from "../../../dataBaseFile/label";
import { ticketCallRequest } from "../../../service/api/ticket/ticketCallRequest";
import PrimaryButton from "../../../jsx/components/button/primaryButton";
import acceptRejectRequest from "../../../service/api/ticket/acceptRejectRequest";
import { resendVideoLink } from "../../../service/api/callHistory/resendVideoLink";
import ResponceToaster from "../../../jsx/components/responceToaster/responceToaster";
import sendCallRequestTicket from "../../../service/api/ticket/sendCallRequestTicket";
import { userById } from "../../../service/api/user/userById";
import { setUserDetails, setUserProfileTab } from "../../../feature/userData/userData";
import AcceptRejectModal from "../../../jsx/components/modalAcceptReject/modalAcceptreject";
import acceptAssignedTicketApi from "../../../service/api/ticket/acceptAssignedTicket";
import CustomTable from "../../../jsx/components/customTable/customTable";
import unavailbleServiceImg from '../../../media/images/servicesAssets/unavailbleServiceImg.png'
import hideServiceRequestApi from "../../../service/api/ticket/hideServiceRequest";

const AvailableJobs = ({
    handleServiceExpand,
    isServiceExpand,
    currentServiceReqId = 0,
    leftHeight = 450
}) => {
    const { role, permissionArr, isVerified, isAvailable, isSubscribedUser, serviceRequestFlagPro, proOptionFlag } = useSelector((state) => state.user);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [page, setPage] = React.useState(1);
    const [pageSize, setPageSize] = useState(25);
    const [totalPage, setTotalPage] = useState(1);
    const [sortByValue, setSortByValue] = useState("DESC");
    const [searchValue, setSearchValue] = useState("");
    const [bulkDeleteArr, setBulkDeleteArr] = useState([]);
    const [skeltonVal, setSkeltonVal] = useState(false);
    const [columnName, setColumnName] = useState("updated_date_dtm");
    const [totalNoRecord, setTotalNoRecord] = useState(0);
    const [elements, setElements] = useState([]);

    const [renderTicketListPro, setRenderTicketListPro] = useState(1);
    const [flag, setFlag] = useState(false);

    const [isChecked, setIsChecked] = useState(false);
    const [firstCheck, setFirstCheck] = useState(false);
    const [loaderEffect, setLoaderEffect] = useState(false);

    const [ticketID, setTicketID] = useState(null);

    const [serviceDetailsObj, setServiceDetailsObj] = useState({});
    const [currentServiceId, setCurrentServiceId] = useState(currentServiceReqId);
    const [isSubscriptionExpired, setIsSubscriptionExpired] = useState(false);

    const [hideServiceRequestLoading, setHideServiceRequestLoading] = useState(false);
    const [hideServiceRequestModalTrigger, setHideServiceRequestModalTrigger] = useState(false);

    const rows = elements;
    const acceptJobsInfo = (
        <Tooltip id="tooltip">
            <strong>
                {`When you enable the "Accept service requests" option, you will start receiving ongoing jobs.`}
            </strong>
        </Tooltip>
    );

    const goToServices = () => {
        navigate("/serviceRequest");
    };

    const getCallHistoryDetails = (res) => {
        // console.log(res, "Res")
        setElements(res.data);
        setTotalNoRecord(res.total_count);
        if (res.total_count % pageSize === 0) {
            setTotalPage(parseInt(res.total_count / pageSize));
        } else {
            setTotalPage(parseInt(res.total_count / pageSize + 1));
        }
    };

    const onLoadData = () => {
        let allTickets = new FormData();
        allTickets.append("page_index", 1);
        allTickets.append("page_size", pageSize);
        allTickets.append("sorting_order", sortByValue);
        allTickets.append("sorting_column_name", "");
        allTickets.append("search_area", searchValue);
        allTickets.append("assigned_flag_ysn", serviceRequestFlagPro === 1 ? 1 : 0);

        dispatch(getTickets(allTickets, (res) => {
            getCallHistoryDetails(res)
            setHideServiceRequestModalTrigger(false);
            setHideServiceRequestLoading(false);
        }));
    };

    useEffect(() => {
        onLoadData();
    }, [serviceRequestFlagPro, proOptionFlag]);

    const [show, setShow] = useState(false);

    const handleClose = () => {
        setShow(false);
        onLoadData();
    };
    const handleShow = (e) => {
        localStorage.setItem("ticket_id", e?.ticket_id_ids);
        localStorage.setItem("ticket_display_name", e?.display_id_int);
        setTicketID(e.ticket_id_ids);
        setShow(true);
        navigate("/serviceRequestDetails");
    };

    function handleGetUserById() {
        let details = {
            user_id_ids: localStorage.getItem("user_id"),
            role_id_int: localStorage.getItem("roleId"),
            user_impersonate_flag: 0,
        };

        dispatch(
            userById(
                details,
                (res) => {
                    setLoaderEffect(false);
                    dispatch(setUserDetails(res.data.data));
                    setIsChecked(res.data.data.is_available_ysn === 1 ? true : false);
                },
                (err) => { }
            )
        );
    }

    const handleToggle = () => {
        setIsChecked(!isChecked);
        setFirstCheck(true);
    };

    useEffect(() => {
        if (isAvailable == 1) {
            setIsChecked(true);
        } else {
            setIsChecked(false);
        }
    }, [isAvailable]);

    useEffect(() => {
        if (firstCheck) {
            setLoaderEffect(true);
            let details = new FormData();

            details.append("user_id_ids", localStorage.getItem("user_id"));
            details.append("user_availability_flag", isChecked ? 1 : 0);
            dispatch(
                updateAvailabilityApi(
                    details,
                    (res) => {
                        // isChecked
                        //     ? localStorage.setItem("triggerFlag", 1)
                        //     : localStorage.setItem("triggerFlag", 0);
                        // setLoaderEffect(false);
                        handleGetUserById();
                        setFirstCheck(false);
                    },
                    (err) => {
                        // console.log(err);
                        setIsChecked(!isChecked);
                        setLoaderEffect(false);
                        alert("Update availability error");
                        setFirstCheck(false);
                    }
                )
            );
        }
    }, [isChecked]);

    useEffect(() => {
        if (rows.length > 0) {
            setServiceDetailsObj(rows[currentServiceId]);
        }
    }, [rows, currentServiceId]);

    useEffect(() => {
        if (Object.keys(serviceDetailsObj).length > 0) {
            ticketStatus();
        }
    }, [serviceDetailsObj]);

    // console.log(serviceDetailsObj, "serviceDetailsObj");
    const handlePrevServiceDetails = () => {
        if (currentServiceId !== 0) {
            setCurrentServiceId(currentServiceId - 1);
        }
    };
    const handleNextServiceDetails = () => {
        if (currentServiceId <= rows.length - 1) {
            setCurrentServiceId(currentServiceId + 1);
        }
    };

    function formatUnixTimestamp(unixTimestamp) {
        const date = new Date(unixTimestamp * 1000);

        const month = date.toLocaleString("default", { month: "short" });
        const day = date.getDate();
        let hour = date.getHours();
        const minute = date.getMinutes();

        const hourFormatted = hour % 12 || 12; // Convert 24-hour time to 12-hour format
        const amPm = hour < 12 ? "am" : "pm";
        const minuteFormatted = minute < 10 ? `0${minute}` : minute;

        return `${month} ${day}, ${hourFormatted}:${minuteFormatted} ${amPm}`;
    }

    const [sentRequest, setSentRequest] = useState([]);
    const [metaDataChr, setMetaDataChr] = useState("");
    const [acceptRejectFlag, setAcceptRejectFlag] = useState();
    const [proAvailableFlag, setProAvailableFlag] = useState(0);
    const [videoJoinLink, setVideoJoinLink] = useState("");
    const [isActiveVideoLink, setIsActiveVideoLink] = useState(0);

    const [roomId, setRoomId] = useState("");
    const [userCallLogIdIds, setUserCallLogIdIds] = useState("");
    const [callLogIdIds, setCallLogIdIds] = useState("");

    function isCurrentUnixTimeLessThan(targetUnixTime) {

        const currentUnixTime = Math.floor(Date.now() / 1000);

        return currentUnixTime < targetUnixTime;
    }

    function ticketStatus() {
        setDialogLoader(true);
        let ticketData = new FormData();

        ticketData.append("ticket_id_ids", serviceDetailsObj?.ticket_id_ids);
        ticketData.append("page_index", 1);
        ticketData.append("page_size", 10);
        ticketData.append("sorting_order", "DESC");
        ticketData.append("sorting_column_name", "");
        ticketData.append("search_area", '');
        ticketData.append("is_accepted_flag", 0);

        // const ticketData = {
        //     ticket_id_ids: ticketID,
        //     search_area: "",
        //     longitute_float: 0,
        //     latitude_float: 0,
        //     page_index: 1,
        //     page_size: 10,
        //     sorting_order: "DESC",
        //     sorting_column_name: "",
        // }

        dispatch(
            ticketCallRequest(
                ticketData,
                (res) => {
                    setSentRequest(res.data.data);
                    setMetaDataChr(res.data.data[0].meta_data_chr);
                    setAcceptRejectFlag(res.data.data[0].is_accepted_ysn);
                    setProAvailableFlag(1);
                    setVideoJoinLink(res.data.data[0].video_link_chr);
                    // setIsActiveVideoLink(res.data.data[0].status_ysn);

                    setDialogLoader(false);
                    setResendLoading(false);

                    if (isCurrentUnixTimeLessThan(res?.data?.data[0]?.video_token_expiry_time)) {
                        // console.log("video token not expired");
                        setIsActiveVideoLink(1);
                    } else {
                        // console.log("video token expired");
                        setIsActiveVideoLink(0);
                    }

                    setRoomId(res.data.data[0].room_id);
                    setUserCallLogIdIds(res.data.data[0].user_call_log_id_ids);
                    setCallLogIdIds(res.data.data[0].call_log_id_ids);
                },
                () => {
                    setDialogLoader(false);
                    setResendLoading(false);
                }
            )
        );
    }

    useEffect(() => {
        localStorage.setItem("roomCode", roomId);
        localStorage.setItem("user_call_log_id_ids", userCallLogIdIds);
        localStorage.setItem("call_log_id", callLogIdIds || "");
    }, [roomId, userCallLogIdIds, callLogIdIds]);

    // Service request Accepting functions
    const [dialogLoader, setDialogLoader] = useState(false);
    const [resendLoading, setResendLoading] = useState(false);

    const [responceMsg, setResponceMsg] = useState("");
    const [updateDocumentsLoading, setUpdateDocumentsLoading] = useState(false);
    const [toasterType, setToasterType] = useState();
    const [handleToaster, setHandleToaster] = useState(false);

    function acceptRejectRequestFn(flag) {
        setDialogLoader(true);
        let details = new FormData();
        details.append("meta_data", metaDataChr);
        details.append("accept_reject_flag", flag);

        dispatch(
            acceptRejectRequest(
                details,
                () => {
                    ticketStatus();
                    // setDialogLoader(false);
                },
                () => {
                    ticketStatus();
                    setDialogLoader(false);
                }
            )
        );

        if (flag == 1) {
            // navigate("/particularTicketDetails")
        }
    }

    //Resend the video link if it expires after accepting the request
    const resendLink = () => {
        setDialogLoader(true);
        setResendLoading(true);
        let resendDetails = {
            user_id_ids: localStorage.getItem("user_id"),
            call_log_id_ids: localStorage.getItem("call_log_id"),
        };
        dispatch(
            resendVideoLink(
                resendDetails,
                (res) => {
                    setResponceMsg(res.data.message);
                    setToasterType("success");
                    ticketStatus();
                    setDialogLoader(false);
                    // setResendLoading(false);

                    // setHandleToaster(true);
                    // setTimeout(() => {
                    //     setHandleToaster(false);
                    // }, 11000);
                },
                (res) => {
                    setResponceMsg(res.data.message);
                    setToasterType("error");

                    ticketStatus();
                    setDialogLoader(false);
                    setResendLoading(false);

                    setHandleToaster(true);
                    setTimeout(() => {
                        setHandleToaster(false);
                    }, 11000);
                }
            )
        );
    };

    // Function to join the video call
    const handleJoinCall = () => {
        setDialogLoader(true);
        let ticketData = new FormData();

        ticketData.append("ticket_id_ids", serviceDetailsObj?.ticket_id_ids);
        ticketData.append("page_index", 1);
        ticketData.append("page_size", 10);
        ticketData.append("sorting_order", "DESC");
        ticketData.append("sorting_column_name", "");
        ticketData.append("search_area", '');
        ticketData.append("is_accepted_flag", 0);

        // const ticketData = {
        //     ticket_id_ids: ticketID,
        //     search_area: "",
        //     longitute_float: 0,
        //     latitude_float: 0,
        //     page_index: 1,
        //     page_size: 10,
        //     sorting_order: "DESC",
        //     sorting_column_name: "",
        // }

        dispatch(
            ticketCallRequest(
                ticketData,
                (res) => {
                    setSentRequest(res?.data?.data);
                    setMetaDataChr(res?.data?.data[0]?.meta_data_chr);
                    setAcceptRejectFlag(res?.data?.data[0]?.is_accepted_ysn);
                    setProAvailableFlag(1);
                    setVideoJoinLink(res?.data?.data[0]?.video_link_chr);
                    // setIsActiveVideoLink(res.data.data[0].status_ysn);

                    setDialogLoader(false);
                    setResendLoading(false);

                    if (isCurrentUnixTimeLessThan(res?.data?.data[0]?.video_token_expiry_time)) {
                        // console.log("video token not expired");
                        setIsActiveVideoLink(1);
                    } else {
                        // console.log("video token expired");
                        setIsActiveVideoLink(0);
                    }

                    setRoomId(res?.data?.data[0]?.room_id);
                    setUserCallLogIdIds(res?.data?.data[0]?.user_call_log_id_ids);
                    setCallLogIdIds(res?.data?.data[0]?.call_log_id_ids);

                    localStorage.setItem("roomCode", res?.data?.data[0]?.room_id);
                    localStorage.setItem("user_call_log_id_ids", res?.data?.data[0]?.user_call_log_id_ids);
                    localStorage.setItem("call_log_id", res?.data?.data[0]?.call_log_id_ids || "");

                    localStorage.setItem("triggerFlag", 1);
                    navigate("/videoCall");
                },
                () => {
                    setDialogLoader(false);
                    setResendLoading(false);
                }
            )
        );
    }

    // Function for accepting the Global Tickets
    function acceptGlobalRequest() {
        if (!isVerified) {
            setHandleToaster(true);
            setToasterType("error");
            setResponceMsg("Please wait for the administrator to approve your profile to accept global service requests.");

            setTimeout(() => {
                setHandleToaster(false);
            }, 11000);

        } else {
            setDialogLoader(true);
            const data = new FormData();

            data.append("ticket_id_ids", serviceDetailsObj?.ticket_id_ids);
            data.append("sender_id_ids", localStorage.getItem("user_id"));
            data.append("reciever_id_ids", serviceDetailsObj.user_id_lng);

            dispatch(
                sendCallRequestTicket(
                    data,
                    (res) => {
                        setResponceMsg(res.data.message);
                        ticketStatus();
                        // particularTicketDetails();
                        setToasterType("success");
                        // navigate('/callHistory')
                        // setDialogLoader(false);

                        // setHandleToaster(true);
                        // setTimeout(() => {
                        //     setHandleToaster(false);
                        // }, 11000);

                        handleJoinCall()
                    },
                    (res) => {

                        setDialogLoader(false);
                        // particularTicketDetails();
                        setResponceMsg(res.data.message);
                        setToasterType("error");

                        onLoadData();

                        setHandleToaster(true);
                        setTimeout(() => {
                            setHandleToaster(false);
                        }, 11000);

                    }
                )
            );
        }
    }

    // Function for accepting the Global Tickets
    const hideSeriveRequestFn = () => {
        setHideServiceRequestLoading(true);
        const data = new FormData();

        data.append("ticket_id_ids", serviceDetailsObj?.ticket_id_ids);
        data.append("sender_id_ids", localStorage.getItem("user_id"));
        data.append("reciever_id_ids", serviceDetailsObj.user_id_lng);

        dispatch(
            hideServiceRequestApi(
                data,
                (res) => {
                    setResponceMsg(res.data.message);
                    // setHideServiceRequestLoading(false);
                    // ticketStatus();
                    // particularTicketDetails();
                    setToasterType("success");
                    // navigate('/callHistory')

                    onLoadData();

                    // setHandleToaster(true);
                    // setTimeout(() => {
                    //     setHandleToaster(false);
                    // }, 11000);

                },
                (res) => {

                    setHideServiceRequestLoading(false);
                    // particularTicketDetails();
                    setResponceMsg(res.data.message);
                    setToasterType("error");

                    setHandleToaster(true);
                    setTimeout(() => {
                        setHandleToaster(false);
                    }, 11000);

                }
            )
        );
    }

    // Function for accepting the Global Tickets 
    const acceptAssignedTicketFn = () => {
        setDialogLoader(true);
        const data = new FormData();

        data.append("ticket_id_ids", serviceDetailsObj?.ticket_id_ids)
        data.append("user_id_ids", localStorage.getItem("user_id"))

        dispatch(
            acceptAssignedTicketApi(data,
                (res) => {
                    setResponceMsg(res.data.message);
                    ticketStatus();
                    // particularTicketDetails();
                    setToasterType("success");
                    // navigate('/callHistory')
                    // setDialogLoader(false);

                    // setHandleToaster(true);
                    // setTimeout(() => {
                    //     setHandleToaster(false);
                    // }, 11000);
                },
                (res) => {

                    setDialogLoader(false);
                    // particularTicketDetails();
                    setResponceMsg(res.data.message);
                    setToasterType("error");

                    setHandleToaster(true);
                    setTimeout(() => {
                        setHandleToaster(false);
                    }, 11000);
                }
            )
        )
    }

    const [attachImageIndex, setAttachImageIndex] = useState(0);

    const handleImageIndex = (index) => {
        setAttachImageIndex(index);
    }

    const handlePrevAttachImg = () => {
        if (attachImageIndex !== 0) {
            setAttachImageIndex(attachImageIndex - 1)
        }
    }
    const handleNextAttachImg = () => {
        if (attachImageIndex <= serviceDetailsObj?.image_urls?.length - 1) {
            setAttachImageIndex(attachImageIndex + 1)
        }
    }

    useEffect(() => {
        setAttachImageIndex(0);
    }, [currentServiceId])


    // Dynamic image height and width
    const imageRef = useRef(null);
    const [imgMaxHeight, setImgMaxHeight] = useState(0);
    const [imgMaxWidth, setImgMaxWidth] = useState(0);

    useEffect(() => {
        if (imageRef.current) {
            const height = imageRef?.current?.getBoundingClientRect().height;
            const width = imageRef?.current?.getBoundingClientRect().width;
            setImgMaxWidth(width);
            setImgMaxHeight(height);
        }


        const resizeObserver = new ResizeObserver(entries => {
            for (let entry of entries) {
                setImgMaxWidth(entry.contentRect.width);
                setImgMaxHeight(entry.contentRect.height);
            }
        });

        if (imageRef.current) {
            resizeObserver.observe(imageRef.current);
        }

        return () => resizeObserver.disconnect();


    }, [imageRef.current, currentServiceId]);

    // useEffect(() => {
    //     const resizeObserver = new ResizeObserver(entries => {
    //         for (let entry of entries) {
    //             setImgMaxWidth(entry.contentRect.width);
    //             setImgMaxHeight(entry.contentRect.height);
    //         }
    //     });

    //     if (imageRef.current) {
    //         resizeObserver.observe(imageRef.current);
    //     }

    //     return () => resizeObserver.disconnect();
    // }, [imageRef.current, currentServiceId]);

    const reDirectToTips = () => {
        navigate('/tipsAndTricks')
    }

    // Zoom functionality for the images
    // State to hold the scale value
    const [scale, setScale] = useState(1);
    const [position, setPosition] = useState({ x: 0, y: 0 });
    const [dragging, setDragging] = useState(false);

    // Function to handle the change in range input
    const handleZoomChange = (event) => {
        setScale(event.target.value);
    };

    // Start dragging
    const handleDragStart = (event) => {
        event.preventDefault();
        setDragging(true);
        // setPosition({
        //     ...position, // Keep the previous position
        //     startX: event.clientX - position.x, // Calculate initial start position
        //     startY: event.clientY - position.y,
        // });
        const clientX = event.type.includes('mouse') ? event.clientX : event.touches[0].clientX;
        const clientY = event.type.includes('mouse') ? event.clientY : event.touches[0].clientY;

        setPosition({
            ...position,
            startX: clientX - position.x,
            startY: clientY - position.y,
        });
    };

    // Handle dragging
    const handleDragging = (event) => {
        if (dragging) {
            // setPosition({
            //     ...position,
            //     x: event.clientX - position.startX,
            //     y: event.clientY - position.startY,
            // });
            const clientX = event.type.includes('mouse') ? event.clientX : event.touches[0].clientX;
            const clientY = event.type.includes('mouse') ? event.clientY : event.touches[0].clientY;

            setPosition({
                ...position,
                x: clientX - position.startX,
                y: clientY - position.startY,
            });
        }
    };

    // Stop dragging
    const handleDragEnd = () => {
        setDragging(false);
    };

    // Reset image
    const handleResetImage = () => {
        setScale(1);
        setPosition({ x: 0, y: 0 });
    }

    useEffect(() => {
        handleResetImage();
        setIsLoadingImg(true);
    }, [attachImageIndex, currentServiceId]);

    // Loading effect for the images
    const [isLoadingImg, setIsLoadingImg] = useState(true);

    const handleImageLoaded = () => {
        setIsLoadingImg(false);
    };

    const handleImageError = () => {
        console.error('Failed to load the image.');
        setIsLoadingImg(false);
    };


    return (
        <>
            <div className="row w-100 h-100" style={{}}>
                <div
                    className="col-12 d-flex flex-column shadow-lg"
                    style={{ borderRadius: '16px' }}
                >
                    {/* Availability check */}
                    {!isServiceExpand &&
                        <div className="row mx-0 pb-2 border-bottom"
                            style={{
                                backgroundColor: '#FBFCFF',
                                borderRadius: '16px 16px 0 0',
                            }}
                        >
                            <div className="align-items-center col-12 d-flex justify-content-between px-1 py-3">
                                <span className="fs-4 px-2" >
                                    {serviceRequestFlagPro !== 1 &&
                                        <OverlayTrigger placement="bottom" overlay={acceptJobsInfo}>
                                            <i className="bi bi-info-circle text-hovered cursor-pointer"></i>
                                        </OverlayTrigger>
                                    }
                                </span>

                                {serviceRequestFlagPro === 1 ?
                                    <>
                                        <div className="d-flex fs-4 font-w500 text-black pe-3 align-items-center position-relative">
                                            <span className="me-2 mt-1">{"My jobs"}</span>
                                        </div>
                                    </> :
                                    <div className="d-flex">
                                        {serviceRequestFlagPro !== 1 && <>
                                            <div className="fs-4 font-w500 text-black pe-3 d-flex align-items-center position-relative">
                                                <span
                                                    className="position-absolute" style={{ left: '-51px', bottom: '-14px' }}
                                                >
                                                    <img src={acceptServiceImg} alt="service" style={{ width: "40px", height: "52px" }} />
                                                </span>

                                                <span className="me-2 mt-1">{"Accept Real-Time Jobs"}</span>
                                                <div>
                                                    {loaderEffect && (
                                                        <Spinner
                                                            animation="border"
                                                            size="lg"
                                                            style={{ width: "20px", height: "20px", color: "orange" }}
                                                        />
                                                    )}
                                                </div>
                                            </div>

                                            <div className="d-flex align-items-center justify-content-center">

                                                <div>
                                                    <Form>
                                                        <Form.Check
                                                            type="switch"
                                                            id="custom-switch"
                                                            className="custom-switch-made"
                                                            // label={isChecked ? "Pause jobs" : "Ready for Jobs"}
                                                            checked={isChecked}
                                                            onChange={handleToggle}
                                                            style={{
                                                                pointerEvents: loaderEffect ? "none" : "auto",
                                                                opacity: loaderEffect ? "0.5" : "1",
                                                            }}
                                                        />
                                                    </Form>
                                                </div>
                                            </div></>}
                                    </div>
                                }

                                <span >
                                </span>

                            </div>

                            {/* <div className="align-items-center col-1 d-flex justify-content-center px-1 py-3">
                            <div className="fs-4 fw-bold text-black pe-3 d-flex align-items-center">
                                {!isServiceExpand ? (
                                    <i
                                        onClick={() => {
                                            handleServiceExpand(currentServiceId);
                                        }}
                                        className="bi bi-arrows-angle-expand cursor-pointer"></i>
                                ) : (
                                    <i
                                        onClick={() => {
                                            handleServiceExpand(currentServiceId);
                                        }}
                                        className="bi bi-arrows-angle-contract cursor-pointer"></i>
                                )}
                            </div>
                        </div> */}
                        </div>
                    }

                    {/* Open Jobs */}
                    <div
                        className="row mx-0 h-100 p-1"

                        style={{
                            backgroundColor: '#FBFCFF',
                            borderRadius: '0 0 16px 16px',
                        }}
                    >
                        {rows.length > 0 ? (
                            <>
                                {serviceRequestFlagPro === 1 ?
                                    <div className="overflow-auto p-2"
                                        style={{ maxHeight: `${leftHeight - 80}px` }}
                                    >
                                        {(elements)?.map((data, id) => (
                                            <>
                                                <div
                                                    key={id}
                                                    className="row mx-0 mt-2 p-2 shadow-lg   cursor-pointer"
                                                    onClick={() => handleShow(data)}
                                                    style={{
                                                        backgroundColor: "rgba(251, 252, 255, 1)",
                                                        borderRadius: '16px',
                                                    }}
                                                >
                                                    <div className="col-12">
                                                        <div
                                                            className="row mx-0 overlay-action-btn"
                                                            style={{
                                                                borderRadius: '16px',
                                                            }}
                                                        >

                                                            <div className='col-12 px-0 d-flex'>

                                                                {/* image */}
                                                                <div
                                                                    className=" d-flex justify-content-center align-items-center border border-light"
                                                                    style={{ height: '75px', borderRadius: '9px' }}
                                                                >
                                                                    {data.image_url ? (
                                                                        <img
                                                                            src={data.image_url}
                                                                            className=""
                                                                            style={{ height: '100%', width: '110px', objectFit: "contain", borderRadius: '9px' }}
                                                                            alt=""
                                                                        />
                                                                    ) : (

                                                                        <img
                                                                            src={unavailbleServiceImg}
                                                                            className=""
                                                                            style={{ height: '100%', width: '110px', objectFit: "", borderRadius: '9px' }}
                                                                            alt=""
                                                                        />

                                                                        // <i
                                                                        //     style={{ fontSize: "20px" }}
                                                                        //     className="bi bi-images"></i>
                                                                    )}
                                                                </div>

                                                                {/* Content */}
                                                                <div className=" px-3 pb-1 w-100">
                                                                    <div className="row  ">
                                                                        <div className="col-6">
                                                                            <span
                                                                                className=" pt-2"
                                                                                style={{
                                                                                    color: "gray !important",
                                                                                    fontSize: "9px",
                                                                                }}>
                                                                                {/* {new Date(
                                                                                    data?.created_date_dtm * 1000
                                                                                ).toLocaleString("en-US", {
                                                                                    month: "short",
                                                                                    day: "numeric",
                                                                                    year: "numeric",
                                                                                })} */}
                                                                                {`${data?.created_date_dtm ?
                                                                                    new Intl.DateTimeFormat("en-US", {
                                                                                        year: "numeric",
                                                                                        month: "short",
                                                                                        day: "numeric",
                                                                                        hour: 'numeric',
                                                                                        minute: 'numeric',
                                                                                        hour12: true
                                                                                    }).format(
                                                                                        data?.created_date_dtm * 1000
                                                                                    ) : '-'}`}
                                                                            </span>
                                                                        </div>
                                                                        <div className="col-6 d-flex justify-content-end">

                                                                            <span className="fs-7 ">#{data?.display_id_int}</span>
                                                                        </div>
                                                                    </div>
                                                                    <div className="row">
                                                                        <div className="col-12 mb-3">
                                                                            <span
                                                                                className="fs-6 text-black "
                                                                                style={{ fontWeight: "800", color: "black" }}>
                                                                                {data?.msg_chr ? data?.msg_chr : data?.problem_description_chr === ("" || null) ? "Problem description not specified" : data?.problem_description_chr}
                                                                            </span>
                                                                        </div>
                                                                    </div>

                                                                    {/* <div className="row">

                                                                        <div className="col-6 d-flex">
                                                                            <div className="fs-7 border border-light px-3 py-1 rounded-pill">
                                                                                <span
                                                                                    className='font-w700'
                                                                                    style={{
                                                                                        color: (data.ticket_status_ysn === 0) ? "rgba(45, 204, 99, 1)" :
                                                                                            (data.ticket_status_ysn === 1 || data.ticket_status_ysn === 5) ? "blue" :
                                                                                                data.ticket_status_ysn === 2 ? "orange" :
                                                                                                    (data.ticket_status_ysn === 4 || data.ticket_status_ysn === 6 || data.ticket_status_ysn === 7) ? "red" : '',
                                                                                    }}
                                                                                >
                                                                                    
                                                                                    {data?.status_display_name_chr}
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-6 d-flex justify-content-end">

                                                                            {data.category_display_name_chr !== ("" || null) ?
                                                                                <span
                                                                                    className="fs-7 px-3 py-1 text-white font-w700 rounded-pill"
                                                                                    style={{
                                                                                        background: "rgba(79, 93, 116, 1)",
                                                                                    }}>
                                                                                    {`${data.category_display_name_chr} ${((data.product_type_chr !== "null") && (data.product_type_chr !== null) && (data.product_type_chr !== "")) ? ` / ${data.product_type_chr}` : ''}`}
                                                                                </span> :
                                                                                <span
                                                                                    className="fs-7 px-3 py-1 text-white font-w700 rounded-pill"
                                                                                    style={{
                                                                                        background: 'rgba(199, 212, 234, 1)'
                                                                                    }}>
                                                                                    {`No category`}
                                                                                </span>
                                                                            }
                                                                        </div>
                                                                    </div> */}
                                                                </div>
                                                            </div>




                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        ))}
                                    </div> :
                                    <>
                                        {/* Open Jobs left side image  */}
                                        <div className="col-lg-6 px-0 "
                                            ref={imageRef}
                                            style={{
                                                // borderRadius: "16px 0 0 16px",
                                            }}
                                        >
                                            <div
                                                className="w-100 h-100 position-relative d-flex align-items-center justify-content-center"
                                                style={{
                                                    background: "#AAA",
                                                    // borderRadius: "15px 0 0 15px",
                                                }}>
                                                {serviceDetailsObj?.category_display_name_chr && (
                                                    <div
                                                        className="position-absolute px-3 py-1 rounded-pill fs-7 text-white font-w600"
                                                        style={{ top: "10px", left: "10px", zIndex: 1, background: 'rgba(79, 93, 116, 1)' }}>
                                                        <span>{` ${serviceDetailsObj?.category_display_name_chr
                                                            } ${((serviceDetailsObj.product_type_chr !== "null") && (serviceDetailsObj.product_type_chr !== null) && (serviceDetailsObj.product_type_chr !== "")) ? `/ ${serviceDetailsObj?.product_type_chr}` : ''}`}
                                                        </span>
                                                    </div>
                                                )}

                                                {serviceDetailsObj?.image_urls?.length > 0 &&
                                                    <div
                                                        className="align-items-center bg-black d-flex fs-7 justify-content-center position-absolute px-3 py-2 w-100"
                                                        style={{ bottom: "0px", left: "50%", transform: "translateX(-50%)", background: 'rgba(244, 248, 255, 1)', zIndex: 1 }}
                                                    >
                                                        {/* New image pagination */}
                                                        <div className="border rounded d-flex " style={{ height: '33px' }}>
                                                            <div
                                                                onClick={() => {
                                                                    handlePrevAttachImg()
                                                                }}
                                                                className="d-flex justify-content-center align-items-center cursor-pointer border-end text-hovered overlay-action-btn fs-5 text-black"
                                                                style={{
                                                                    width: '30px',
                                                                    pointerEvents: attachImageIndex === 0 ? 'none' : 'auto',
                                                                    opacity: attachImageIndex === 0 ? '0.5' : '1'
                                                                }}
                                                            >
                                                                <i class="bi bi-chevron-left"></i>
                                                            </div>
                                                            <div className="d-flex justify-content-center align-items-center" style={{ width: '50px' }}>
                                                                <span className="fs-5 font-w600" style={{ color: '#FF8934' }}>{`${attachImageIndex + 1}`}</span> &nbsp;{`/`}&nbsp;
                                                                <span className="fs-5 font-w600">{`${serviceDetailsObj?.image_urls?.length}`}</span>
                                                            </div>
                                                            <div
                                                                onClick={() => {
                                                                    handleNextAttachImg()
                                                                }}
                                                                className="d-flex justify-content-center align-items-center border-start cursor-pointer text-hovered overlay-action-btn fs-5 text-black"
                                                                style={{
                                                                    width: '30px',
                                                                    pointerEvents: (attachImageIndex >= serviceDetailsObj?.image_urls?.length - 1) ? 'none' : 'auto',
                                                                    opacity: (attachImageIndex >= serviceDetailsObj?.image_urls?.length - 1) ? '0.5' : '1'
                                                                }}
                                                            >
                                                                <i class="bi bi-chevron-right"></i>
                                                            </div>
                                                        </div>

                                                        {/* Old image pagination */}
                                                        {/* {serviceDetailsObj?.image_urls?.map((attachment, index) => {
                                                    return (
                                                        <div
                                                            className={`rounded-circle bg-white cursor-pointer me-2`}
                                                            onClick={() => handleImageIndex(index)}
                                                            style={{
                                                                height: '10px',
                                                                width: '10px',
                                                                border: index === attachImageIndex ? '1px solid black' : '',
                                                                opacity: index === attachImageIndex ? '1' : '0.7'
                                                            }}
                                                        >

                                                        </div>
                                                    )
                                                })} */}

                                                        <div className="d-flex align-items-center justify-content-center ps-2">
                                                            <span className="fs-6 font-w600 pe-1">{`Zoom`}</span>
                                                            <input
                                                                className=""
                                                                type="range"
                                                                min="1"
                                                                max="3"
                                                                value={scale}
                                                                step="0.1"
                                                                onChange={handleZoomChange}
                                                                style={{
                                                                    width: '80px',
                                                                    margin: '20px 0',
                                                                    cursor: 'pointer',
                                                                    background: 'linear-gradient(to right, #ddd 0%, #ddd 100%)',
                                                                    borderRadius: '5px',
                                                                    height: '4px',
                                                                    outline: 'none',
                                                                    opacity: '0.7',
                                                                    transition: 'opacity 0.2s',
                                                                }}
                                                            />
                                                            {(scale !== 1 || position.x !== 0 || position.y !== 0) &&
                                                                <div className=' ms-2'>
                                                                    <div className="tooltipCustom">
                                                                        <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content' }}>{"Reset photo"}</span>
                                                                        <i
                                                                            class="bi bi-arrow-clockwise fs-4 text-black text-hovered cursor-pointer"
                                                                            onClick={() => {
                                                                                handleResetImage();
                                                                            }}
                                                                        ></i>
                                                                    </div>
                                                                </div>
                                                            }
                                                        </div>
                                                    </div>
                                                }


                                                {serviceDetailsObj?.image_url ? (
                                                    <div
                                                        // ref={imageRef}
                                                        className="align-items-center border-end d-flex  justify-content-center "
                                                    >
                                                        {isLoadingImg &&
                                                            <div
                                                                className="d-flex align-items-center justify-content-center"
                                                                style={{
                                                                    maxWidth: `${imgMaxWidth}px`,
                                                                    maxHeight: `${imgMaxHeight}px`,
                                                                    minWidth: `${imgMaxWidth}px`,
                                                                    minHeight: `${imgMaxHeight < 251 ? '250px' : `${imgMaxHeight}px`}`,
                                                                    width: "100%",
                                                                    height: "100%",
                                                                }}
                                                            >
                                                                <Spinner animation="border" size="lg" style={{}} />
                                                            </div>
                                                        }
                                                        <div
                                                            className="overflow-hidden"
                                                            style={{ cursor: dragging ? 'grabbing' : 'grab' }}
                                                            onMouseMove={handleDragging}
                                                            onMouseLeave={handleDragEnd}
                                                            onMouseUp={handleDragEnd}
                                                            onTouchMove={handleDragging}
                                                            onTouchEnd={handleDragEnd}
                                                        >
                                                            <img
                                                                src={serviceDetailsObj?.image_urls?.[attachImageIndex]}
                                                                alt=""
                                                                className=""
                                                                onLoad={handleImageLoaded}
                                                                onError={handleImageError}
                                                                onMouseDown={handleDragStart}
                                                                onTouchStart={handleDragStart}
                                                                style={{
                                                                    maxWidth: `${imgMaxWidth}px`,
                                                                    maxHeight: `${imgMaxHeight}px`,
                                                                    minWidth: `${imgMaxWidth}px`,
                                                                    minHeight: `${imgMaxHeight < 251 ? '250px' : `${imgMaxHeight}px`}`,
                                                                    width: "100%",
                                                                    height: "100%",
                                                                    objectFit: "contain",
                                                                    // borderRadius: "15px 0 0 15px",
                                                                    transition: 'transform 0.25s ease',
                                                                    transformOrigin: 'center',
                                                                    transform: `scale(${scale}) translate(${position.x}px, ${position.y}px)`,
                                                                    cursor: dragging ? 'grabbing' : 'grab',
                                                                    display: isLoadingImg ? 'none' : 'block'
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div
                                                        className="fs-1 text-white border-end d-flex  justify-content-center align-items-center"
                                                        style={{
                                                            maxWidth: `${imgMaxWidth}px`,
                                                            maxHeight: `${imgMaxHeight}px`,
                                                            minWidth: `${imgMaxWidth}px`,
                                                            minHeight: `${imgMaxHeight < 251 ? '250px' : `${imgMaxHeight}px`}`,
                                                            width: "100%",
                                                            height: "100%",
                                                        }}
                                                    >
                                                        <i class="bi bi-file-image-fill"></i>
                                                    </div>
                                                )}

                                            </div>
                                        </div>

                                        {/* Open Jobs rigth side content  */}
                                        <div className="col-lg-6 px-0 bg-transparent d-flex flex-column justify-content-between">
                                            <div className="" style={{ minHeight: isServiceExpand ? "50vh" : "" }}>
                                                <div className="row mx-0"
                                                    style={{
                                                        // borderRadius: "0 15px 0 0",
                                                        background: ' rgba(235, 240, 250, 1)'
                                                    }}
                                                >
                                                    <div className="align-items-center col-12 d-flex fs-4 fw-bold justify-content-center px-0 py-3 text-black position-relative">
                                                        <span>{`${currentServiceId + 1} of ${rows.length
                                                            } ${serviceRequestFlagPro ? 'services' : 'open jobs'}`}</span>

                                                        <div className="align-items-center d-flex justify-content-center px-1 py-3 position-absolute end-0">
                                                            <div className="fs-4 fw-bold text-black pe-3 d-flex align-items-center">
                                                                {!isServiceExpand ? (
                                                                    <i
                                                                        onClick={() => {
                                                                            handleServiceExpand(currentServiceId);
                                                                        }}
                                                                        className="bi bi-arrows-angle-expand cursor-pointer"></i>
                                                                ) : (
                                                                    <i
                                                                        onClick={() => {
                                                                            handleServiceExpand(currentServiceId);
                                                                        }}
                                                                        className="bi bi-arrows-angle-contract cursor-pointer"></i>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="row mx-0 mt-2 fs-7">
                                                    <div className="col-4 ps-3 d-flex align-items-center justify-content-start border-end">
                                                        {/* <span>
                                                            {formatUnixTimestamp(
                                                                serviceDetailsObj?.created_date_dtm
                                                            )}
                                                        </span> */}
                                                        <span className="">{`${serviceDetailsObj?.created_date_dtm ?
                                                            new Intl.DateTimeFormat("en-US", {
                                                                year: "numeric",
                                                                month: "short",
                                                                day: "numeric",
                                                                hour: 'numeric',
                                                                minute: 'numeric',
                                                                hour12: true
                                                            }).format(
                                                                serviceDetailsObj?.created_date_dtm * 1000
                                                            ) : '-'}`}</span>
                                                    </div>

                                                    <div className="col-7 px-2 d-flex align-items-center justify-content-start">
                                                        <span>
                                                            {serviceDetailsObj?.created_by_name_chr
                                                                ? `${serviceDetailsObj?.created_by_name_chr}`
                                                                : ""}
                                                        </span>
                                                    </div>

                                                    <div className="col-1 pe-3 d-flex align-items-center justify-content-end">
                                                        <span>{`#${serviceDetailsObj?.display_id_int
                                                            ? serviceDetailsObj?.display_id_int
                                                            : ""
                                                            }`}
                                                        </span>
                                                    </div>
                                                </div>

                                                <div className="row mx-0 mt-2 mb-4">
                                                    <div className="align-items-center col-12 d-flex fs-4 fw-bold justify-content-start px-3 text-black">
                                                        <span>{`${serviceDetailsObj?.problem_description_chr
                                                            ? serviceDetailsObj?.problem_description_chr
                                                            : "Problem description not specified"
                                                            }`}</span>
                                                    </div>
                                                </div>
                                            </div>

                                            {false && <div className="row mx-0 mb-3 mt-4">
                                                <div className="col-12 px-3">
                                                    <div className="row mx-0">
                                                        <div className="col-2 pe-2">
                                                            <div
                                                                onClick={() => {
                                                                    handlePrevServiceDetails();
                                                                }}
                                                                className="text-hovered overlay-action-btn border border-dark rounded-2 w-100 h-100 d-flex align-items-center justify-content-center fs-4 fw-bold cursor-pointer"
                                                                style={{
                                                                    pointerEvents: currentServiceId === 0 ? "none" : "auto",
                                                                    opacity: currentServiceId === 0 ? "0.5" : "1",

                                                                }}
                                                            >
                                                                <i className="bi bi-arrow-left"></i>
                                                            </div>
                                                        </div>

                                                        <div className="col-8 pe-2 ">
                                                            {/* <Button
                                                        className='w-100 rounded-0 border border-none d-flex align-items-center justify-content-center font-w500 '
                                                        style={{ background: '#1FC758', }}
                                                    >
                                                        {"Accept"}
                                                        <span className='ps-2'>
                                                            <i className="bi bi-check-lg"></i>
                                                        </span>
                                                    </Button> */}

                                                            <>
                                                                {sentRequest.length > 0 ? (
                                                                    role !== 2 && acceptRejectFlag == 0 ? (
                                                                        <>
                                                                            <div>
                                                                                <PrimaryButton
                                                                                    onClick={() => {
                                                                                        acceptRejectRequestFn(1);
                                                                                    }}
                                                                                    buttonName={btnAcceptService.toUpperCase()}
                                                                                    style={{
                                                                                        width: '100%',
                                                                                        background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                                                        border: '2px solid rgba(255, 154, 32, 1)',
                                                                                        boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                                                    }}
                                                                                />
                                                                            </div>
                                                                            <div style={{ marginLeft: "4px" }}>
                                                                                <PrimaryButton
                                                                                    className={
                                                                                        "w-100 rounded-0 border border-none font-w500"
                                                                                    }
                                                                                    onClick={() => {
                                                                                        acceptRejectRequestFn(0);
                                                                                    }}
                                                                                    buttonName={btnRejectService.toUpperCase()}
                                                                                    style={{ background: "red", width: "100%" }}
                                                                                />
                                                                            </div>
                                                                        </>
                                                                    ) : role !== 2 && acceptRejectFlag == 1 ? (
                                                                        <>
                                                                            {serviceDetailsObj.ticket_status_ysn !==
                                                                                0 && (
                                                                                    <>
                                                                                        {isActiveVideoLink == 1 ? (
                                                                                            <>
                                                                                                {/* <PrimaryButton
                                                                                            onClick={() => { localStorage.setItem("triggerFlag", 1); navigate("/videoCall") }}
                                                                                            buttonName={btnJoinVideo}
                                                                                            style={{ background: '#1FC758', border:'none', borderRadius:'0px !important', width:'100%' }}
                                                                                        /> */}

                                                                                                <Button
                                                                                                    className="w-100 rounded-2 d-flex align-items-center justify-content-center font-w500 "
                                                                                                    style={{
                                                                                                        border: 'none',
                                                                                                        background: 'linear-gradient(142.98deg, #16BA4E 1.99%, #19DF5C 99.97%)',
                                                                                                        boxShadow: '0px 6px 12px 0px rgba(45, 204, 99, 0.24)',
                                                                                                    }}
                                                                                                    onClick={() => {
                                                                                                        localStorage.setItem(
                                                                                                            "triggerFlag",
                                                                                                            1
                                                                                                        );
                                                                                                        navigate("/videoCall");
                                                                                                    }}>
                                                                                                    {btnJoinVideo.toUpperCase()}
                                                                                                    {/* <span className='ps-2'>
                                                                                                <i className="bi bi-check-lg"></i>
                                                                                            </span> */}
                                                                                                </Button>
                                                                                            </>
                                                                                        ) : (
                                                                                            <PrimaryButton
                                                                                                className={
                                                                                                    "w-100 rounded-2  border-none font-w500"
                                                                                                }
                                                                                                buttonName={btnResendLink.toUpperCase()}
                                                                                                onClick={() => {
                                                                                                    resendLink();
                                                                                                }}
                                                                                                loadingMessage="loading..."
                                                                                                isLoading={resendLoading}
                                                                                                style={{
                                                                                                    // background: "#1FC758",
                                                                                                    width: "100%",
                                                                                                    border: 'none',
                                                                                                    background: 'linear-gradient(142.98deg, #16BA4E 1.99%, #19DF5C 99.97%)',
                                                                                                    boxShadow: '0px 6px 12px 0px rgba(45, 204, 99, 0.24)',
                                                                                                }}
                                                                                            />
                                                                                        )}
                                                                                    </>
                                                                                )}
                                                                        </>
                                                                    ) : role !== 2 && acceptRejectFlag == 2 ? (
                                                                        <>
                                                                            <Button
                                                                                className="w-100 rounded-0 border border-none d-flex align-items-center justify-content-center font-w500 "
                                                                                disabled
                                                                                style={{
                                                                                    width: '100%',
                                                                                    background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                                                    border: '2px solid rgba(255, 154, 32, 1)',
                                                                                    boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                                                }}
                                                                            >
                                                                                {btnRejectedServiceMsg.toUpperCase()}
                                                                            </Button>
                                                                        </>
                                                                    ) : role !== 2 && acceptRejectFlag == 3 ? (
                                                                        <>
                                                                            <Button
                                                                                className="w-100 rounded-2 border border-none d-flex align-items-center justify-content-center font-w500 "
                                                                                disabled
                                                                                style={{
                                                                                    width: '100%',
                                                                                    background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                                                    border: '2px solid rgba(255, 154, 32, 1)',
                                                                                    boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                                                }}
                                                                            >
                                                                                {`CLOSED`}
                                                                            </Button>
                                                                        </>
                                                                    ) : null
                                                                ) : (
                                                                    role !== 2 && (
                                                                        <>
                                                                            {serviceDetailsObj?.ticket_status_ysn ===
                                                                                0 && (
                                                                                    <Button
                                                                                        className="w-100 rounded-2 border border-none d-flex align-items-center justify-content-center font-w500 "
                                                                                        disabled
                                                                                        style={{
                                                                                            width: '100%',
                                                                                            background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                                                            border: '2px solid rgba(255, 154, 32, 1)',
                                                                                            boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                                                        }}
                                                                                    >
                                                                                        {txtClosed.toUpperCase()}
                                                                                    </Button>
                                                                                )}
                                                                            {serviceDetailsObj?.ticket_status_ysn === 1 && (
                                                                                <>
                                                                                    {/* <PrimaryButton
                                                                            onClick={() => { acceptGlobalRequest() }}
                                                                            buttonName={btnAcceptService}
                                                                            isLoading={dialogLoader}
                                                                            loadingMessage={'please wait...'}
                                                                        /> */}

                                                                                    <Button
                                                                                        className="w-100 rounded-2 border-none d-flex align-items-center justify-content-center font-w500 "
                                                                                        onClick={() => {
                                                                                            acceptGlobalRequest();
                                                                                        }}
                                                                                        style={{
                                                                                            // background: "#1FC758",
                                                                                            pointerEvents: dialogLoader
                                                                                                ? "none"
                                                                                                : "auto",
                                                                                            opacity: dialogLoader ? "0.5" : "1",
                                                                                            width: '100%',
                                                                                            border: 'none',
                                                                                            background: 'linear-gradient(142.98deg, #16BA4E 1.99%, #19DF5C 99.97%)',
                                                                                            boxShadow: '0px 6px 12px 0px rgba(45, 204, 99, 0.24)',
                                                                                        }}>
                                                                                        {dialogLoader ? "Loading..." : "ACCEPT"}
                                                                                        {!dialogLoader &&
                                                                                            <span className='ps-2'>
                                                                                                <i className="bi bi-check-lg"></i>
                                                                                            </span>
                                                                                        }
                                                                                    </Button>
                                                                                </>
                                                                            )}
                                                                            {serviceDetailsObj?.ticket_status_ysn ===
                                                                                2 && (
                                                                                    <Button
                                                                                        disabled
                                                                                        className="w-100 rounded-2 border-none d-flex align-items-center justify-content-center font-w500 "
                                                                                        style={{
                                                                                            width: '100%',
                                                                                            border: 'none',
                                                                                            background: 'linear-gradient(142.98deg, #16BA4E 1.99%, #19DF5C 99.97%)',
                                                                                            boxShadow: '0px 6px 12px 0px rgba(45, 204, 99, 0.24)',
                                                                                        }}>
                                                                                        {"ACCEPTED BY OTHER"}
                                                                                    </Button>
                                                                                )}
                                                                            {serviceDetailsObj?.ticket_status_ysn ===
                                                                                3 && (
                                                                                    <>
                                                                                        {/* <Button disabled>
                                                                            {btnRejectedService}
                                                                        </Button> */}
                                                                                        <Button
                                                                                            disabled
                                                                                            style={{
                                                                                                background: "#1FC758",
                                                                                                border: "none",
                                                                                                borderRadius: "0px !important",
                                                                                            }}>
                                                                                            {btnRejectedService.toUpperCase()}
                                                                                        </Button>
                                                                                    </>
                                                                                )}
                                                                            {serviceDetailsObj?.ticket_status_ysn ===
                                                                                4 && (
                                                                                    <>
                                                                                        {/* <Button disabled>
                                                                         {btnRejectedService}
                                                                     </Button> */}
                                                                                        <Button
                                                                                            disabled
                                                                                            className="w-100 rounded-2  border-none d-flex align-items-center justify-content-center font-w500 "
                                                                                            style={{
                                                                                                // background: "#1FC758",
                                                                                                // border: "none",
                                                                                                width: '100%',
                                                                                                background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                                                                border: '2px solid rgba(255, 154, 32, 1)',
                                                                                                boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                                                            }}>
                                                                                            {txtClosed.toUpperCase()}
                                                                                        </Button>
                                                                                    </>
                                                                                )}

                                                                            {serviceDetailsObj?.ticket_status_ysn === 5 && (
                                                                                <>
                                                                                    {/* <PrimaryButton onClick={() => { acceptGlobalRequest() }} buttonName={btnConnect} */}

                                                                                    {/* <PrimaryButton
                                                                            onClick={() => { acceptGlobalRequest() }}
                                                                            buttonName={btnAcceptService}
                                                                            isLoading={dialogLoader}
                                                                            loadingMessage={'please wait...'}
                                                                        /> */}

                                                                                    <Button
                                                                                        className="w-100 rounded-0 border border-none d-flex align-items-center justify-content-center font-w500 "
                                                                                        onClick={() => {
                                                                                            acceptGlobalRequest();
                                                                                        }}
                                                                                        style={{
                                                                                            // background: "#1FC758",
                                                                                            pointerEvents: dialogLoader
                                                                                                ? "none"
                                                                                                : "auto",
                                                                                            opacity: dialogLoader ? "0.5" : "1",
                                                                                            width: '100%',
                                                                                            border: 'none',
                                                                                            background: 'linear-gradient(142.98deg, #16BA4E 1.99%, #19DF5C 99.97%)',
                                                                                            boxShadow: '0px 6px 12px 0px rgba(45, 204, 99, 0.24)',
                                                                                        }}>
                                                                                        {dialogLoader ? "Loading..." : "ACCEPT"}
                                                                                        {!dialogLoader &&
                                                                                            <span className='ps-2'>
                                                                                                <i className="bi bi-check-lg"></i>
                                                                                            </span>
                                                                                        }
                                                                                    </Button>
                                                                                </>
                                                                            )}

                                                                            {serviceDetailsObj?.ticket_status_ysn ===
                                                                                6 && (
                                                                                    <>
                                                                                        {/* <Button disabled>
                                                                         {btnRejectedService}
                                                                     </Button> */}
                                                                                        <Button
                                                                                            disabled
                                                                                            className="w-100 rounded-2 border border-none d-flex align-items-center justify-content-center font-w500 "
                                                                                            style={{
                                                                                                background: "#1FC758",
                                                                                                // border: "none",
                                                                                                // borderRadius: "0px !important",
                                                                                            }}>
                                                                                            {"INCOMPLETE"}
                                                                                        </Button>
                                                                                    </>
                                                                                )}

                                                                            {serviceDetailsObj?.ticket_status_ysn ===
                                                                                7 && (
                                                                                    <>
                                                                                        {/* <Button disabled>
                                                                         {btnRejectedService}
                                                                     </Button> */}

                                                                                        <Button
                                                                                            disabled
                                                                                            className="w-100 bg-danger rounded-2 border-none d-flex align-items-center justify-content-center font-w500 "
                                                                                            style={{
                                                                                                border: "none",
                                                                                                borderRadius: "0px !important",
                                                                                            }}>
                                                                                            {"CANCELLED"}
                                                                                        </Button>
                                                                                    </>
                                                                                )}
                                                                        </>
                                                                    )
                                                                )}
                                                            </>
                                                        </div>

                                                        <div className="col-2 pe-1 ">
                                                            <div
                                                                onClick={() => {
                                                                    handleNextServiceDetails();
                                                                }}
                                                                className="text-hovered border border-dark overlay-action-btn rounded-2  w-100 h-100 d-flex align-items-center justify-content-center fs-4 fw-bold  cursor-pointer"
                                                                style={{
                                                                    pointerEvents:
                                                                        currentServiceId >= rows.length - 1
                                                                            ? "none"
                                                                            : "auto",
                                                                    opacity:
                                                                        currentServiceId >= rows.length - 1
                                                                            ? "0.5"
                                                                            : "1",

                                                                }}>
                                                                <i className="bi bi-arrow-right"></i>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* <div className='row mx-0'>
                                                <div className='col-2 pe-2' >
                                                    <div onClick={() => { handlePrevServiceDetails() }} className='overlay-action-btn border w-100 h-100 d-flex align-items-center justify-content-center fs-4 fw-bold text-black border border-dark cursor-pointer' style={{ pointerEvents: currentServiceId === 0 ? 'none' : 'auto', opacity: currentServiceId === 0 ? '0.5' : '1' }}>
                                                        <i className="bi bi-arrow-left"></i>
                                                    </div>
                                                </div>

                                                <div className='col-8 pe-2 '>
                                                    <Button
                                                        className='w-100 rounded-0 border border-none d-flex align-items-center justify-content-center font-w500 '
                                                        style={{ background: '#1FC758', }}
                                                    >
                                                        {"Accept"}
                                                        <span className='ps-2'>
                                                            <i className="bi bi-check-lg"></i>
                                                        </span>
                                                    </Button>
                                                </div>

                                                <div className='col-2 pe-1 '>
                                                    <div onClick={() => { handleNextServiceDetails() }} className='overlay-action-btn border w-100 h-100 d-flex align-items-center justify-content-center fs-4 fw-bold text-black border border-dark cursor-pointer' style={{ pointerEvents: (currentServiceId >= rows.length - 1) ? 'none' : 'auto', opacity: (currentServiceId >= rows.length - 1) ? '0.5' : '1' }}>
                                                        <i className="bi bi-arrow-right"></i>
                                                    </div>
                                                </div>
                                            </div> */}
                                                </div>
                                            </div>}
                                        </div>

                                        {/* Bottom action btn */}
                                        <div className="row mx-0 py-2 border-top">
                                            <div className="col-12 px-2">
                                                <div className="row mx-0 ">

                                                    <div className="d-flex align-items-center">
                                                        <div className="h-100">
                                                            <div
                                                                onClick={() => {
                                                                    handlePrevServiceDetails();
                                                                }}
                                                                className="text-hovered overlay-action-btn border border-dark rounded-2 h-100 d-flex align-items-center justify-content-center fs-4 fw-bold cursor-pointer"
                                                                style={{
                                                                    pointerEvents: currentServiceId === 0 ? "none" : "auto",
                                                                    opacity: currentServiceId === 0 ? "0.5" : "1",
                                                                    width: '50px'
                                                                }}
                                                            >
                                                                <i className="bi bi-arrow-left"></i>
                                                            </div>
                                                        </div>

                                                        <div
                                                            className="row w-100 px-2"
                                                            style={{
                                                                pointerEvents: hideServiceRequestLoading ? "none" : "auto",
                                                                opacity: hideServiceRequestLoading ? "0.5" : "1",
                                                            }}
                                                        >
                                                            <div className="col-md-6 pe-md-1 pb-1">
                                                                {/* <Button
                                                                    className='w-100 rounded-0 border border-none d-flex align-items-center justify-content-center font-w500 '
                                                                    style={{ background: '#1FC758', }}
                                                                >
                                                                    {"Accept"}
                                                                    <span className='ps-2'>
                                                                        <i className="bi bi-check-lg"></i>
                                                                    </span>
                                                                </Button> */}

                                                                <>
                                                                    {sentRequest.length > 0 ? (
                                                                        role !== 2 && acceptRejectFlag == 0 ? (
                                                                            <>
                                                                                <div>
                                                                                    <PrimaryButton
                                                                                        onClick={() => {

                                                                                            acceptGlobalRequest();
                                                                                            // Changes in flow all Pro's able to accept global services keep commencted code
                                                                                            // if (!isSubscribedUser) {
                                                                                            //     setIsSubscriptionExpired(true)
                                                                                            // } else {
                                                                                            //     acceptRejectRequestFn(1);
                                                                                            // }
                                                                                        }}
                                                                                        buttonName={btnAcceptService.toUpperCase()}
                                                                                        style={{
                                                                                            width: '100%',
                                                                                            background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                                                            border: '2px solid rgba(255, 154, 32, 1)',
                                                                                            boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                                                        }}
                                                                                    />
                                                                                </div>
                                                                                <div style={{ marginLeft: "4px" }}>
                                                                                    <PrimaryButton
                                                                                        className={
                                                                                            "w-100 rounded-0 border border-none font-w500"
                                                                                        }
                                                                                        onClick={() => {
                                                                                            acceptRejectRequestFn(0);
                                                                                        }}
                                                                                        buttonName={btnRejectService.toUpperCase()}
                                                                                        style={{ background: "red", width: "100%" }}
                                                                                    />
                                                                                </div>
                                                                            </>
                                                                        ) : role !== 2 && acceptRejectFlag == 1 ? (
                                                                            <>
                                                                                {serviceDetailsObj.ticket_status_ysn !== 0 && (
                                                                                    <>
                                                                                        {isActiveVideoLink == 1 ? (
                                                                                            <>
                                                                                                {/* <PrimaryButton
                                                                                            onClick={() => { localStorage.setItem("triggerFlag", 1); navigate("/videoCall") }}
                                                                                            buttonName={btnJoinVideo}
                                                                                            style={{ background: '#1FC758', border:'none', borderRadius:'0px !important', width:'100%' }}
                                                                                        /> */}

                                                                                                <Button
                                                                                                    className="w-100 rounded-2 d-flex align-items-center justify-content-center font-w500 "
                                                                                                    style={{
                                                                                                        border: 'none',
                                                                                                        background: 'linear-gradient(142.98deg, #16BA4E 1.99%, #19DF5C 99.97%)',
                                                                                                        boxShadow: '0px 6px 12px 0px rgba(45, 204, 99, 0.24)',
                                                                                                    }}
                                                                                                    onClick={() => {
                                                                                                        localStorage.setItem(
                                                                                                            "triggerFlag",
                                                                                                            1
                                                                                                        );
                                                                                                        navigate("/videoCall");
                                                                                                    }}>
                                                                                                    {btnJoinVideo.toUpperCase()}
                                                                                                    {/* <span className='ps-2'>
                                                                                                <i className="bi bi-check-lg"></i>
                                                                                            </span> */}
                                                                                                </Button>
                                                                                            </>
                                                                                        ) : (
                                                                                            <PrimaryButton
                                                                                                className={
                                                                                                    "w-100 rounded-2  border-none font-w500"
                                                                                                }
                                                                                                buttonName={btnResendLink.toUpperCase()}
                                                                                                onClick={() => {
                                                                                                    resendLink();
                                                                                                }}
                                                                                                loadingMessage="loading..."
                                                                                                isLoading={resendLoading}
                                                                                                style={{
                                                                                                    // background: "#1FC758",
                                                                                                    width: "100%",
                                                                                                    border: 'none',
                                                                                                    background: 'linear-gradient(142.98deg, #16BA4E 1.99%, #19DF5C 99.97%)',
                                                                                                    boxShadow: '0px 6px 12px 0px rgba(45, 204, 99, 0.24)',
                                                                                                }}
                                                                                            />
                                                                                        )}
                                                                                    </>
                                                                                )}
                                                                            </>
                                                                        ) : role !== 2 && acceptRejectFlag == 2 ? (
                                                                            <>
                                                                                <Button
                                                                                    className="w-100 rounded-0 border border-none d-flex align-items-center justify-content-center font-w500 "
                                                                                    disabled
                                                                                    style={{
                                                                                        width: '100%',
                                                                                        background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                                                        border: '2px solid rgba(255, 154, 32, 1)',
                                                                                        boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                                                    }}
                                                                                >
                                                                                    {btnRejectedServiceMsg.toUpperCase()}
                                                                                </Button>
                                                                            </>
                                                                        ) : role !== 2 && acceptRejectFlag == 3 ? (
                                                                            <>
                                                                                <Button
                                                                                    className="w-100 rounded-2 border border-none d-flex align-items-center justify-content-center font-w500 "
                                                                                    disabled
                                                                                    style={{
                                                                                        width: '100%',
                                                                                        background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                                                        border: '2px solid rgba(255, 154, 32, 1)',
                                                                                        boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                                                    }}
                                                                                >
                                                                                    {`CLOSED`}
                                                                                </Button>
                                                                            </>
                                                                        ) : null
                                                                    ) : (
                                                                        role !== 2 && (
                                                                            <>
                                                                                {serviceDetailsObj?.ticket_status_ysn === 0 && (
                                                                                    <Button
                                                                                        className="w-100 rounded-2 border border-none d-flex align-items-center justify-content-center font-w500 "
                                                                                        disabled
                                                                                        style={{
                                                                                            width: '100%',
                                                                                            background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                                                            border: '2px solid rgba(255, 154, 32, 1)',
                                                                                            boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                                                        }}
                                                                                    >
                                                                                        {txtClosed.toUpperCase()}
                                                                                    </Button>
                                                                                )}
                                                                                {((serviceDetailsObj?.ticket_status_ysn === 1) &&
                                                                                    <>
                                                                                        {/* <PrimaryButton
                                                                            onClick={() => { acceptGlobalRequest() }}
                                                                            buttonName={btnAcceptService}
                                                                            isLoading={dialogLoader}
                                                                            loadingMessage={'please wait...'}
                                                                        /> */}

                                                                                        <Button
                                                                                            className="w-100 rounded-2 border-none d-flex align-items-center justify-content-center font-w500 "
                                                                                            onClick={() => {
                                                                                                acceptGlobalRequest();
                                                                                                // if (!isSubscribedUser) {
                                                                                                //     setIsSubscriptionExpired(true)
                                                                                                // } else {
                                                                                                //     acceptGlobalRequest();
                                                                                                // }
                                                                                            }}
                                                                                            style={{
                                                                                                // background: "#1FC758",
                                                                                                pointerEvents: dialogLoader
                                                                                                    ? "none"
                                                                                                    : "auto",
                                                                                                opacity: dialogLoader ? "0.5" : "1",
                                                                                                width: '100%',
                                                                                                border: 'none',
                                                                                                background: 'linear-gradient(142.98deg, #16BA4E 1.99%, #19DF5C 99.97%)',
                                                                                                boxShadow: '0px 6px 12px 0px rgba(45, 204, 99, 0.24)',
                                                                                            }}>
                                                                                            {dialogLoader ? "Loading..." : "ACCEPT"}
                                                                                            {!dialogLoader &&
                                                                                                <span className='ps-2'>
                                                                                                    <i className="bi bi-check-lg"></i>
                                                                                                </span>
                                                                                            }
                                                                                        </Button>
                                                                                    </>
                                                                                )}
                                                                                {serviceDetailsObj?.ticket_status_ysn ===
                                                                                    2 && (
                                                                                        <Button
                                                                                            disabled
                                                                                            className="w-100 rounded-2 border-none d-flex align-items-center justify-content-center font-w500 "
                                                                                            style={{
                                                                                                width: '100%',
                                                                                                border: 'none',
                                                                                                background: 'linear-gradient(142.98deg, #16BA4E 1.99%, #19DF5C 99.97%)',
                                                                                                boxShadow: '0px 6px 12px 0px rgba(45, 204, 99, 0.24)',
                                                                                            }}>
                                                                                            {"ACCEPTED BY OTHER"}
                                                                                        </Button>
                                                                                    )}
                                                                                {serviceDetailsObj?.ticket_status_ysn ===
                                                                                    3 && (
                                                                                        <>
                                                                                            {/* <Button disabled>
                                                                            {btnRejectedService}
                                                                        </Button> */}
                                                                                            <Button
                                                                                                disabled
                                                                                                style={{
                                                                                                    background: "#1FC758",
                                                                                                    border: "none",
                                                                                                    borderRadius: "0px !important",
                                                                                                }}>
                                                                                                {btnRejectedService.toUpperCase()}
                                                                                            </Button>
                                                                                        </>
                                                                                    )}
                                                                                {serviceDetailsObj?.ticket_status_ysn ===
                                                                                    4 && (
                                                                                        <>
                                                                                            {/* <Button disabled>
                                                                         {btnRejectedService}
                                                                     </Button> */}
                                                                                            <Button
                                                                                                disabled
                                                                                                className="w-100 rounded-2  border-none d-flex align-items-center justify-content-center font-w500 "
                                                                                                style={{
                                                                                                    // background: "#1FC758",
                                                                                                    // border: "none",
                                                                                                    width: '100%',
                                                                                                    background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                                                                    border: '2px solid rgba(255, 154, 32, 1)',
                                                                                                    boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                                                                }}>
                                                                                                {txtClosed.toUpperCase()}
                                                                                            </Button>
                                                                                        </>
                                                                                    )}

                                                                                {serviceDetailsObj?.ticket_status_ysn === 5 && (
                                                                                    <>
                                                                                        {/* <PrimaryButton onClick={() => { acceptGlobalRequest() }} buttonName={btnConnect} */}

                                                                                        {/* <PrimaryButton
                                                                            onClick={() => { acceptGlobalRequest() }}
                                                                            buttonName={btnAcceptService}
                                                                            isLoading={dialogLoader}
                                                                            loadingMessage={'please wait...'}
                                                                        /> */}

                                                                                        <Button
                                                                                            className="w-100 rounded-2 border border-none d-flex align-items-center justify-content-center font-w500 "
                                                                                            onClick={() => {
                                                                                                acceptGlobalRequest();
                                                                                                // if (!isSubscribedUser) {
                                                                                                //     setIsSubscriptionExpired(true)
                                                                                                // } else {
                                                                                                //     acceptGlobalRequest();
                                                                                                // }
                                                                                            }}
                                                                                            style={{
                                                                                                // background: "#1FC758",
                                                                                                pointerEvents: dialogLoader
                                                                                                    ? "none"
                                                                                                    : "auto",
                                                                                                opacity: dialogLoader ? "0.5" : "1",
                                                                                                width: '100%',
                                                                                                border: 'none',
                                                                                                background: 'linear-gradient(142.98deg, #16BA4E 1.99%, #19DF5C 99.97%)',
                                                                                                boxShadow: '0px 6px 12px 0px rgba(45, 204, 99, 0.24)',
                                                                                            }}>
                                                                                            {dialogLoader ? "Loading..." : "ACCEPT"}
                                                                                            {!dialogLoader &&
                                                                                                <span className='ps-2'>
                                                                                                    <i className="bi bi-check-lg"></i>
                                                                                                </span>
                                                                                            }
                                                                                        </Button>
                                                                                    </>
                                                                                )}

                                                                                {serviceDetailsObj?.ticket_status_ysn ===
                                                                                    6 && (
                                                                                        <>
                                                                                            {/* <Button disabled>
                                                                         {btnRejectedService}
                                                                     </Button> */}
                                                                                            <Button
                                                                                                disabled
                                                                                                className="w-100 rounded-2 border border-none d-flex align-items-center justify-content-center font-w500 "
                                                                                                style={{
                                                                                                    background: "#1FC758",
                                                                                                    // border: "none",
                                                                                                    // borderRadius: "0px !important",
                                                                                                }}>
                                                                                                {"INCOMPLETE"}
                                                                                            </Button>
                                                                                        </>
                                                                                    )}

                                                                                {serviceDetailsObj?.ticket_status_ysn ===
                                                                                    7 && (
                                                                                        <>
                                                                                            {/* <Button disabled>
                                                                         {btnRejectedService}
                                                                     </Button> */}

                                                                                            <Button
                                                                                                disabled
                                                                                                className="w-100 bg-danger rounded-2 border-none d-flex align-items-center justify-content-center font-w500 "
                                                                                                style={{
                                                                                                    border: "none",
                                                                                                    borderRadius: "0px !important",
                                                                                                }}>
                                                                                                {"CANCELLED"}
                                                                                            </Button>
                                                                                        </>
                                                                                    )
                                                                                }

                                                                                {(serviceDetailsObj?.ticket_status_ysn === 10) &&
                                                                                    <>
                                                                                        {/* <PrimaryButton
                                                                            onClick={() => { acceptGlobalRequest() }}
                                                                            buttonName={btnAcceptService}
                                                                            isLoading={dialogLoader}
                                                                            loadingMessage={'please wait...'}
                                                                        /> */}

                                                                                        <Button
                                                                                            className="w-100 rounded-2 border-none d-flex align-items-center justify-content-center font-w500 "
                                                                                            onClick={() => {
                                                                                                acceptGlobalRequest();
                                                                                                // if (!isSubscribedUser) {
                                                                                                //     setIsSubscriptionExpired(true)
                                                                                                // } else {
                                                                                                //     acceptAssignedTicketFn();
                                                                                                // }
                                                                                            }}
                                                                                            style={{
                                                                                                // background: "#1FC758",
                                                                                                pointerEvents: dialogLoader
                                                                                                    ? "none"
                                                                                                    : "auto",
                                                                                                opacity: dialogLoader ? "0.5" : "1",
                                                                                                width: '100%',
                                                                                                border: 'none',
                                                                                                background: 'linear-gradient(142.98deg, #16BA4E 1.99%, #19DF5C 99.97%)',
                                                                                                boxShadow: '0px 6px 12px 0px rgba(45, 204, 99, 0.24)',
                                                                                            }}>
                                                                                            {dialogLoader ? "Loading..." : "ACCEPT"}
                                                                                            {!dialogLoader &&
                                                                                                <span className='ps-2'>
                                                                                                    <i className="bi bi-check-lg"></i>
                                                                                                </span>
                                                                                            }
                                                                                        </Button>
                                                                                    </>
                                                                                }
                                                                            </>
                                                                        )
                                                                    )}
                                                                </>
                                                            </div>

                                                            <div className="col-md-6 ps-md-1 pb-1">
                                                                <Button
                                                                    className='w-100 rounded-2 d-flex align-items-center justify-content-center font-w500 '
                                                                    onClick={() => {
                                                                        // hideSeriveRequestFn();
                                                                        setHideServiceRequestModalTrigger(true);
                                                                    }}
                                                                    style={{
                                                                        background: 'linear-gradient(142.98deg, #E02D2D 1.99%, #FF5C5C 99.97%)',
                                                                        boxShadow: '0px 6px 12px 0px rgba(240, 72, 72, 0.24)',
                                                                        border: 'none',
                                                                    }}
                                                                >
                                                                    {hideServiceRequestLoading ? "Loading..." : "HIDE"}
                                                                    <span className='ps-2'>
                                                                        <i className="bi bi-eye-slash"></i>
                                                                    </span>
                                                                </Button>
                                                            </div>
                                                        </div>


                                                        <div className="h-100 ">
                                                            <div
                                                                onClick={() => {
                                                                    handleNextServiceDetails();
                                                                }}
                                                                className="text-hovered border border-dark overlay-action-btn rounded-2 h-100 d-flex align-items-center justify-content-center fs-4 fw-bold  cursor-pointer"
                                                                style={{
                                                                    pointerEvents:
                                                                        currentServiceId >= rows.length - 1
                                                                            ? "none"
                                                                            : "auto",
                                                                    opacity:
                                                                        currentServiceId >= rows.length - 1
                                                                            ? "0.5"
                                                                            : "1",
                                                                    width: '50px'
                                                                }}>
                                                                <i className="bi bi-arrow-right"></i>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* <div className='row mx-0'>
                                                <div className='col-2 pe-2' >
                                                    <div onClick={() => { handlePrevServiceDetails() }} className='overlay-action-btn border w-100 h-100 d-flex align-items-center justify-content-center fs-4 fw-bold text-black border border-dark cursor-pointer' style={{ pointerEvents: currentServiceId === 0 ? 'none' : 'auto', opacity: currentServiceId === 0 ? '0.5' : '1' }}>
                                                        <i className="bi bi-arrow-left"></i>
                                                    </div>
                                                </div>

                                                <div className='col-8 pe-2 '>
                                                    <Button
                                                        className='w-100 rounded-0 border border-none d-flex align-items-center justify-content-center font-w500 '
                                                        style={{ background: '#1FC758', }}
                                                    >
                                                        {"Accept"}
                                                        <span className='ps-2'>
                                                            <i className="bi bi-check-lg"></i>
                                                        </span>
                                                    </Button>
                                                </div>

                                                <div className='col-2 pe-1 '>
                                                    <div onClick={() => { handleNextServiceDetails() }} className='overlay-action-btn border w-100 h-100 d-flex align-items-center justify-content-center fs-4 fw-bold text-black border border-dark cursor-pointer' style={{ pointerEvents: (currentServiceId >= rows.length - 1) ? 'none' : 'auto', opacity: (currentServiceId >= rows.length - 1) ? '0.5' : '1' }}>
                                                        <i className="bi bi-arrow-right"></i>
                                                    </div>
                                                </div>
                                            </div> */}
                                            </div>
                                        </div>
                                    </>}
                            </>
                        ) : (
                            <>
                                {/* <div
                                    className="align-items-center bg-light col-12 d-flex fs-4 fw-bold justify-content-center px-0 py-3 text-black"
                                    style={{
                                        maxHeight: "50px",
                                        borderRadius: '15px 15px 0px 0px'
                                    }}>
                                    <span>{"No open jobs at the moment"}</span>
                                </div> */}

                                <div
                                    className="align-items-center col-12 d-flex justify-content-center px-0 py-3 flex-column"
                                    style={{
                                        // height:'calc(100% - 50px)',
                                    }}
                                >
                                    {/* <div> */}
                                    <div className="text-black fs-3 fw-bold mb-2 text-center">
                                        <span>{serviceRequestFlagPro == 1 ? 'No services created yet' : "No open jobs at the moment"}</span>
                                    </div>
                                    <div className="text-black fs-5 text-center">
                                        <span>
                                            {
                                                "Follow our Tip & Tricks to get more open jobs that match your expertise"
                                            }
                                        </span>
                                    </div>
                                    <div onClick={reDirectToTips} className="mt-3 cursor-pointer  text-center text-hovered d-flex align-items-center">
                                        <span className="font-w600 pe-1">{"Learn more"}</span>{" "}
                                        <span>
                                            <i className="bi bi-chevron-right"></i>
                                        </span>
                                    </div>
                                    {/* </div> */}
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>

            {/* Modal for delete notes starts */}
            <Modal
                className="fade"
                show={hideServiceRequestModalTrigger}
                // onHide={handleClose}
                centered>
                <Modal.Body>
                    <div className="row mx-0">
                        <div className="col-12 px-0">
                            <div className="row mx-0">
                                <div className="col-12 px-0 d-flex align-items-center justify-content-end fs-4 text-black">
                                    <span
                                        onClick={() => setHideServiceRequestModalTrigger(false)}
                                        className="cursor-pointer">
                                        <i className="bi bi-x-lg"></i>
                                    </span>
                                </div>
                            </div>

                            <div className="row mx-0 mb-3">
                                <div className="fw-bold col-12 px-0 d-flex align-items-center justify-content-center fs-3 text-black">
                                    <span className="">{"Hide Service Request"}</span>
                                </div>
                            </div>

                            <div className="row mx-0 mt-3 pb-2">
                                <div className="col-12 px-0 font-w600 d-flex justify-content-center align-items-center">
                                    <span className="fs-5">
                                        {"Are you sure you want to hide this service request?"}
                                    </span>
                                </div>
                            </div>

                            {/* <div className="row mx-0 text-black mt-2">
                                <div className="col-12 px-0 font-w600">
                                    <PrimaryButton
                                        onClick={(e) => handleCloseModalNotes()}
                                        buttonName={"Cancel"}
                                        style={{
                                            width: "100%",
                                            backgroundColor: "white",
                                            border: "none",
                                            color: "grey",
                                        }}
                                    />
                                </div>
                            </div> */}

                            <div className="row mx-0 text-black mt-2">
                                <div className="col-sm-6 pe-sm-2 font-w600">
                                    <PrimaryButton
                                        onClick={(e) => setHideServiceRequestModalTrigger(false)}
                                        buttonName={"CANCEL"}
                                        style={{
                                            width: "100%",
                                            background: 'rgba(251, 252, 255, 1)',
                                            border: '1px solid rgba(199, 212, 234, 1)',
                                            color: "black",
                                            boxShadow: '0px 6px 12px 0px rgba(102, 129, 172, 0.12)',
                                            fontWeight: '600',
                                        }}
                                    />
                                </div>

                                <div className="col-sm-6 ps-sm-2 font-w600">
                                    <PrimaryButton
                                        onClick={(e) => hideSeriveRequestFn()}
                                        buttonName={"YES, HIDE IT"}
                                        loadingMessage={"Hiding..."}
                                        isLoading={hideServiceRequestLoading}
                                        style={{
                                            width: "100%",
                                            background: 'linear-gradient(142.98deg, #E02D2D 1.99%, #FF5C5C 99.97%)',
                                            boxShadow: '0px 6px 12px 0px rgba(240, 72, 72, 0.24)',
                                            border: '1px solid rgba(240, 72, 72, 1)',
                                            fontWeight: '600',
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            {/* Subscription check */}
            <>
                <AcceptRejectModal
                    modalStatus={isSubscriptionExpired}
                    text={`Please upgrade your subscription to accept service.`}
                    onClickReject={() => {
                        setIsSubscriptionExpired(false)
                    }}
                    onClickAccept={() => {
                        setIsSubscriptionExpired(false)
                        navigate('/userProfile')
                        dispatch(setUserProfileTab(5))
                    }}
                    yesBtnTxt={`BUY NOW`}
                    noBtnTxt={"NO, GO BACK"}
                />
            </>

            {handleToaster && (
                <ResponceToaster toasterType={toasterType} message={responceMsg} />
            )}
        </>
    );
};

export default AvailableJobs;
